import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { timezoneStringLabel } from '../../../dateUtils';
var EmployerInterviewCard = /*#__PURE__*/function (_React$Component) {
  function EmployerInterviewCard(props) {
    var _this;
    _classCallCheck(this, EmployerInterviewCard);
    _this = _callSuper(this, EmployerInterviewCard, [props]);
    _this.state = {
      isHovering: false
    };
    return _this;
  }
  _inherits(EmployerInterviewCard, _React$Component);
  return _createClass(EmployerInterviewCard, [{
    key: "handleInterviewCardClicked",
    value: function handleInterviewCardClicked() {
      var interview = this.props.interview;
      window.location.href = interview.interview_path;
    }
  }, {
    key: "renderInterviewTime",
    value: function renderInterviewTime() {
      var interview = this.props.interview;
      if (interview.type === 'pending' || interview.type === 'reschedule') {
        return /*#__PURE__*/React.createElement("div", {
          className: "body-text-1 medium-weight"
        }, "Interview pending ".concat(interview.type === 'pending' ? ' confirmation' : ' reschedule'));
      }
      var dateStr = interview.accepted_time.date;
      var startTimeStr = interview.accepted_time.start_time;
      var endTimeStr = interview.accepted_time.end_time;
      var startTimeMoment = moment("".concat(dateStr, " ").concat(startTimeStr));
      var endTimeMoment = moment("".concat(dateStr, " ").concat(endTimeStr));
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-1 medium-weight"
      }, startTimeMoment.format('ddd, MMM D, YYYY'), "\xA0 \xB7 \xA0", startTimeMoment.format('h:mm a'), "\xA0 - \xA0", endTimeMoment.format('h:mm a'), /*#__PURE__*/React.createElement("span", {
        className: "ms-3 timezone muted-gray-text normal-weight"
      }, timezoneStringLabel(interview.timezone)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var interview = this.props.interview;
      var isHovering = this.state.isHovering;
      return /*#__PURE__*/React.createElement("div", {
        className: "employer-interview-card width-790-centered",
        id: interview.id,
        onClick: function onClick() {
          return _this2.handleInterviewCardClicked();
        },
        onMouseOver: function onMouseOver() {
          return _this2.setState({
            isHovering: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            isHovering: false
          });
        },
        role: "button",
        tabIndex: "0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "employer-interview-card-content"
      }, this.renderInterviewTime(interview)), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
        className: "employer-interview-card-content g-row--always g-row--between"
      }, /*#__PURE__*/React.createElement("div", {
        className: "interview-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "consultant-interview-info medium-weight body-text-2 mb-8"
      }, "Interview with", ' ', interview.candidate_name, ' ', "(Round", ' ', interview.round_number, ")"), /*#__PURE__*/React.createElement("div", {
        className: "interview-project-name normal-weight body-text-2"
      }, interview.project_name)), /*#__PURE__*/React.createElement("a", {
        className: "".concat(isHovering ? 'green' : 'gray', " interview-view-more-link medium-weight"),
        href: interview.interview_path,
        role: "button",
        tabIndex: "0"
      }, isHovering && /*#__PURE__*/React.createElement("span", {
        className: "body-text-2"
      }, "View More"), /*#__PURE__*/React.createElement("i", {
        className: "ml-7 fas fa-angle-right arrowhead"
      }))));
    }
  }]);
}(React.Component);
EmployerInterviewCard.propTypes = {
  interview: PropTypes.shape({
    project_name: PropTypes.string.isRequired,
    candidate_name: PropTypes.string.isRequired,
    round_number: PropTypes.number.isRequired,
    timezone: PropTypes.string.isRequired,
    interview_path: PropTypes.string.isRequired
  }).isRequired
};
export default EmployerInterviewCard;